// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3ffau","requiredAsterisk":"Info_requiredAsterisk__3wpsB"};